export enum ClientType {
    SelfServe = "SelfServe",
    Partnership = "Partnership",
    Unset = "Unset"
  }